import { FeatureQueryKeys, createQueryKeys } from './createQueryKeys';
import { UseFeatureMutation, createUseFeatureMutation } from './useFeatureMutation';
import { useFeatureQuery } from './useFeatureQuery';

export interface FeatureApi {
  keys: FeatureQueryKeys;
  useFeatureQuery: typeof useFeatureQuery;
  useFeatureMutation: UseFeatureMutation;
}

export function createFeatureApi(root: string): FeatureApi {
  const keys = createQueryKeys(root);
  return {
    keys,
    useFeatureQuery,
    useFeatureMutation: createUseFeatureMutation([keys.all]),
  };
}
